var React = require('react');

function Network (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"64","height":"64","rx":"32","fill":"#66FF8F","fillOpacity":"0.1","key":0}),React.createElement("path",{"d":"M44 33.5C44 42.5 32 46.5 32 46.5C32 46.5 20 42.5 20 33.5V21.5L32 18.5L44 21.5V33.5Z","stroke":"#66FF8F","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M26 33.5L29.5 37L38 27.5","stroke":"#66FF8F","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"square","key":2})]);
}

Network.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = Network;

Network.default = Network;
